import { KeyValueModel } from "model";
import { EnumTipoArquivo } from "model/enums/enum-tipo-arquivo";

export const TipoArquivoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoArquivo.Remessa, "Remessa"),
    new KeyValueModel(EnumTipoArquivo.Retorno, "Retorno"),
    new KeyValueModel(EnumTipoArquivo.NFe, 'NFe')
];